var map = {
	"./arrow.svg": 9442,
	"./bootstrap.svg": 2786,
	"./close.svg": 2591,
	"./code.svg": 9465,
	"./css.svg": 2445,
	"./download.svg": 3221,
	"./express.svg": 6818,
	"./figma.svg": 7731,
	"./git.svg": 4022,
	"./github.svg": 7078,
	"./html.svg": 4063,
	"./illustrator.svg": 9146,
	"./javascript.svg": 954,
	"./json.svg": 2198,
	"./link.svg": 7407,
	"./linkedin.svg": 5205,
	"./linux.svg": 5415,
	"./minus.svg": 8032,
	"./mongodb.svg": 3587,
	"./moon.svg": 2294,
	"./mysql.svg": 1798,
	"./nodeJs.svg": 9758,
	"./photoshop.svg": 2692,
	"./php.svg": 7811,
	"./plus.svg": 4893,
	"./projectArrow.svg": 6248,
	"./react.svg": 1218,
	"./sass.svg": 2387,
	"./send.svg": 637,
	"./send2.svg": 5724,
	"./sun.svg": 948,
	"./techs/css.svg": 9920,
	"./techs/express.svg": 5859,
	"./techs/git.svg": 9908,
	"./techs/github.svg": 4436,
	"./techs/html.svg": 7024,
	"./techs/javascript.svg": 3782,
	"./techs/mongodb.svg": 345,
	"./techs/mysql.svg": 2537,
	"./techs/node.svg": 4419,
	"./techs/php.svg": 2347,
	"./techs/react.svg": 549,
	"./techs/scss.svg": 2769,
	"./techs/vue.svg": 1011,
	"./techs/webpack.svg": 7126,
	"./techs/wordpress.svg": 8458,
	"./tools.svg": 1540,
	"./vueJs.svg": 8831,
	"./webpack.svg": 658,
	"./wordpress.svg": 6391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1199;